import { Injectable } from '@angular/core';

export interface BusinessForgotPasswordState {
  nif?: string;
  cif?: string;
  email?: string;
  phone?: string;
  updatePasswordToken?: string;
  validatePinToken?: string;
  result?: ResultInfo;
}

export interface ResultInfo {
  isSuccess: boolean;
  token?: string;
  newPassword?: string;
}

@Injectable({
  providedIn: 'root',
})
export class BusinessesPasswordRecoveryContextService {
  private state: BusinessForgotPasswordState;
  constructor() {}

  get result() {
    return this.state?.result;
  }

  getState() {
    return this.state;
  }

  updateState(newState: BusinessForgotPasswordState) {
    this.state = { ...this.state, ...newState };
  }

  updateResult(result: ResultInfo) {
    this.state = { ...this.state, ...{ result } };
  }

  clear() {
    this.state = {};
  }
}
